import { Map } from "immutable";
import { CategoryPks } from "../../../constants";

export const MENU_ID = 'menuId';

const initialState = Map({
  [MENU_ID]: CategoryPks["tin-tuc"]
});

export default initialState;